import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import { SpeakersUIProvider } from './SpeakersContextProvider';

const SpeakersList = React.lazy(() => import('./Speakers'));

function Speakers(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست منتورها</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <SpeakersUIProvider>
          <SpeakersList {...props} />
        </SpeakersUIProvider>
      </Suspense>
    </Page>
  );
}

export default Speakers;
